"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var createStyles_1 = __importDefault(require("@material-ui/styles/createStyles"));
exports.styles = createStyles_1.default({
    container: {
        width: '100%',
        padding: [8, 24],
        overflowY: 'auto',
    },
});
